import { SelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useGetSelectOptions } from '../hooks';

interface ReservationStatusFilterProps {
    name: string;
    reservationStatusOptions: Record<string, TextKey>;
}

export const ReservationStatusFilter = ({ name, reservationStatusOptions }: ReservationStatusFilterProps) => {
    const options = useGetSelectOptions(reservationStatusOptions);

    return <SelectField label={lt('LedgersReservationStatus')} name={name} options={options} multiselect />;
};
